import { render, staticRenderFns } from "./AccountSettingsAdditionalMenu.vue?vue&type=template&id=076ad5c2&scoped=true"
import script from "./AccountSettingsAdditionalMenu.vue?vue&type=script&lang=js"
export * from "./AccountSettingsAdditionalMenu.vue?vue&type=script&lang=js"
import style0 from "./AccountSettingsAdditionalMenu.vue?vue&type=style&index=0&id=076ad5c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076ad5c2",
  null
  
)

export default component.exports